import React from 'react';
import { ClockIcon, UsersIcon, ShieldCheckIcon, GiftIcon } from 'lucide-react';
import { useIntersectionObserver } from './useIntersectionObserver';
export function WhatYouGet() {
  const {
    elementRef,
    isVisible
  } = useIntersectionObserver();
  const hacks = [{
    icon: <ClockIcon className="w-8 h-8 text-gold-primary" data-id="element-148" />,
    title: 'Hack #1: La Regla del Viaje al Pasado',
    description: 'Cómo revisar tus taxes de hace 3 años y encontrar dinero que ya dabas por perdido.'
  }, {
    icon: <UsersIcon className="w-8 h-8 text-gold-primary" data-id="element-149" />,
    title: 'Hack #2: El Doble Salario del Dependiente',
    description: 'El método exacto para que tu hijo (incluso si está en el Army o tiene un trabajo part-time) sea tu dependiente y recupere su propio dinero al mismo tiempo.'
  }, {
    icon: <ShieldCheckIcon className="w-8 h-8 text-gold-primary" data-id="element-150" />,
    title: 'Hack #3: El Escudo del Plan de Pagos',
    description: 'Por qué deberle al IRS puede ser tu mejor movimiento financiero del año si sabes invertir ese capital.'
  }];
  return <section className="bg-navy-dark py-16 md:py-24" data-id="element-151">
      <div ref={elementRef} className={`max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 fade-in-section ${isVisible ? 'is-visible' : ''}`} data-id="element-152">
        <div className="text-center mb-12" data-id="element-153">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-154">
            Lo que recibirás hoy
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-155">
            He condensado mis mejores estrategias en una guía digital de lectura
            rápida (30 min) para que dejes de perder dinero hoy mismo:
          </p>
        </div>

        <div className="space-y-6" data-id="element-156">
          {hacks.map((hack, index) => <div key={index} className="bg-navy-light p-6 md:p-8 rounded-xl border border-gold-primary/20 hover:border-gold-primary/50 transition-colors" data-id="element-157">
              <div className="flex flex-col md:flex-row gap-4 md:gap-6 items-start" data-id="element-158">
                <div className="bg-navy-dark p-3 rounded-lg border border-white/5" data-id="element-159">
                  {hack.icon}
                </div>
                <div data-id="element-160">
                  <h3 className="text-xl md:text-2xl font-bold text-gold-light mb-2" data-id="element-161">
                    {hack.title}
                  </h3>
                  <p className="text-lg md:text-xl text-gray-300" data-id="element-162">
                    {hack.description}
                  </p>
                </div>
              </div>
            </div>)}

          {/* Bonus */}
          <div className="bg-gradient-to-br from-gold-primary/20 to-navy-light p-1 rounded-xl mt-8" data-id="element-163">
            <div className="bg-navy-dark p-6 md:p-8 rounded-lg flex flex-col md:flex-row gap-4 md:gap-6 items-start" data-id="element-164">
              <div className="bg-gold-primary/20 p-3 rounded-lg border border-gold-primary/30" data-id="element-165">
                <GiftIcon className="w-8 h-8 text-gold-primary" data-id="element-166" />
              </div>
              <div data-id="element-167">
                <div className="inline-block bg-gold-primary text-navy-dark text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider mb-3" data-id="element-168">
                  Bono Extra Gratuito
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-white mb-2" data-id="element-169">
                  La lista de los 5 créditos fiscales
                </h3>
                <p className="text-lg md:text-xl text-gray-300" data-id="element-170">
                  Que el 80% de los contribuyentes ignora por completo.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}